import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/warren.svg";
var WarrenSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  WarrenSolid_default as default
};
